import styled, { css } from "styled-components";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import { Tag } from "components/designV2/tag/tag";

export const RowCard = styled.div`
  background: ${ColorV2.White};
  border-radius: 24px;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 1416px;
  max-width: 100%;
  margin-top: 16px;
`;

export const RowSection = styled.div<{
  $leftColumnWidth?: number;
  $columnGap?: number;
}>`
  display: grid;
  grid-template-columns: ${(props) =>
      props.$leftColumnWidth ? `${props.$leftColumnWidth}px` : "280px"} 1fr;
  gap: ${(props) => props.$columnGap ?? 24}px;
  align-items: center;
`;

export const RowInfo = styled.div`
  display: flex;
  align-items: center;
`;

export const RowSectionMeta = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding-left: 58px;
  color: ${ColorV2.Blue4};
`;

export const RowSectionRole = styled.span`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue4};
`;

export const ScheduleTag = styled(Tag)`
  max-width: 80px;
  overflow: hidden;

  > span {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const MonthInfo = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;

export const MonthAvatar = styled.div<{ $backgroundColor?: ColorV2 }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${(props) => props.$backgroundColor ?? ColorV2.White};
  border: 1px solid ${ColorV2.Blue6};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const MonthAvatarImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const MonthName = styled.div`
  ${TypographyV2.b1};
  color: ${ColorV2.Blue1};
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const MonthInfoSpacer = styled.div`
  height: 32px;
`;

export const RowSectionSlots = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
`;

export const RowGrid = styled.div<{ $columns: number; $gap?: number }>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.$columns}, minmax(0, 1fr));
  gap: ${(props) => props.$gap ?? 16}px;
  width: 100%;
  min-width: 0;
`;

type ShiftBlockSize = "small" | "large" | "pill";

export const CellHoverAction = styled.button.attrs({
  "data-cell-hover": "true",
})<{ $size: ShiftBlockSize }>`
  ${TypographyV2.s1};
  position: absolute;
  inset: 0;
  border: none;
  background: ${ColorV2.Blue6};
  color: ${ColorV2.Blue4};
  border-radius: 12px;
  opacity: 0;
  pointer-events: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.15s ease;
  cursor: pointer;

  ${(props) =>
    props.$size === "pill" &&
    css`
      inset: auto;
      width: 24px;
      height: 26px;
      border-radius: 8px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    `}
`;

export const ScheduleRowCell = styled.div<{
  $justify?: "center" | "flex-start";
  $offset?: number;
}>`
  display: flex;
  align-items: center;
  justify-content: ${(props) => props.$justify ?? "center"};
  margin-left: ${(props) => (props.$offset ? `${props.$offset}px` : "0")};
  min-width: 0;
  position: relative;

  &:hover [data-cell-hover="true"] {
    opacity: 0.5;
    pointer-events: auto;
  }
`;
